import ModalDefault from '../components/modal-default';

class ComingSoonTemplate {
	constructor() {
		this.filmsWrapper = document.querySelector('.tmpl-coming-soon__films-wrapper');

		this.init();
		this.modals = [];
	}

	showSpinner = () => {
		const spinner = document.querySelector('.ui__spin-loader');

		if (spinner) {
			spinner.style.display = 'block';
		}
	};

	hideSpinner = () => {
		const spinner = document.querySelector('.ui__spin-loader');

		if (spinner) {
			spinner.style.display = 'none';
		}
	};

	init = async () => {
		const data = await this.fetchDocumentaries();

		this.updateContent(data);
	};

	fetchDocumentaries = async () => {
		this.showSpinner();

		let endpoint = '/wp-json/wp/v2/film-meta?showing=coming-soon&reverse-sort=true';
		let retryEndpoint ='/wp-json/wp/v2/film-meta?show_all&showing=streaming-now&reverse-sort=true';

		// Update endpoint for subdirectory site
		if (window.location.pathname.includes('independentlens')) {
			endpoint =
				'/independentlens/wp-json/wp/v2/film-meta?showing=coming-soon&reverse-sort=true';
			retryEndpoint =
				'/independentlens/wp-json/wp/v2/film-meta?show_all&showing=streaming-now&reverse-sort=true';
		}

		let data = await fetch(endpoint)
			.then((response) => response.json())
			.then((res) => {
				const documentaries = res.films.reverse();
				const { pagination } = res;
				this.hideSpinner();
				return {
					documentaries: documentaries,
					pagination: pagination
				};
			})
			.catch((error) => console.error('Error:', error));

		if (!data?.documentaries?.length) {
			const title = document.querySelector('.tmpl-coming-soon__heading');
			title.textContent = 'Streaming Now';
			data = fetch(retryEndpoint)
				.then((response) => response.json())
				.then((res) => {
					const documentaries = res.films.reverse();
					const { pagination } = res;
					this.hideSpinner();
					return {
						documentaries: documentaries,
						pagination: pagination
					};
				})
				.catch((error) => console.error('Error:', error));
		}

		return data;
	};

	updateContent = (data) => {
		const { documentaries } = data;

		this.filmsWrapper.innerHTML = '';
		if (documentaries.length === 0) {
			this.filmsWrapper.innerHTML =
				' <div class="columns small-12"> <h4>No results found</h4> </div> ';
		}
		documentaries.forEach((documentary) => {
			const cardMarkup = documentary.film_card_markup;
			this.filmsWrapper.innerHTML += cardMarkup;
		});

		Array.from(document.querySelectorAll('.js__modal--default')).forEach((modalDefaultEl) => {
			this.modals.push(new ModalDefault(modalDefaultEl));
		});
	};
}

export default ComingSoonTemplate;
